import { useSelector } from "react-redux";
import { useGetBooksQuery } from "../../features/api/apiSlice";
import BookItem from "./BookItem";

export default function BookList() {
	const { searchText, tag } = useSelector((state) => state.filter);

	const { data: books, isLoading, isError } = useGetBooksQuery();

	let content = null;
	if (isLoading) {
		content = <div>Books are loading...</div>;
	} 
    else if (!isLoading && isError) {
		content = <div>The was an error</div>;
	} 
    else if (!isLoading && !isError && books?.length === 0) {
		content = <div>No books found!</div>;
	} 
    else if (!isLoading && !isError && books?.length > 0) {
		let filteredBooks = books.map((book) => ({ ...book }));
		if (tag === "Featured") {
			filteredBooks = filteredBooks.filter((book) => book.featured);
		}
		if (searchText !== "") {
			filteredBooks = filteredBooks.filter((book) =>
				book.name?.toLowerCase().includes(searchText?.toLowerCase())
			);
		}

		content = filteredBooks.map((book) => (
			<BookItem key={book.id} book={book} />
		));
	}

	return (
		<div className="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
			{content}
		</div>
	);
}
